/**
 * Web Vitals reporting — GUIA_REACT_v2 §7.3.
 *
 * Se mide CLS, LCP, INP, FCP y TTFB. En producción se envía a Firebase
 * Analytics (si está disponible) y/o a un endpoint custom; en dev se loguea.
 */
import { onCLS, onLCP, onINP, onFCP, onTTFB, type Metric } from 'web-vitals';

import { analyticsPromise } from '../firebase/firebaseConfig';

type Reporter = (metric: Metric) => void;

const consoleReporter: Reporter = (metric) => {
  if (import.meta.env.DEV) {
    console.info(`[web-vitals] ${metric.name}: ${metric.value.toFixed(2)} (${metric.rating})`);
  }
};

const analyticsReporter: Reporter = (metric) => {
  void analyticsPromise.then((analytics) => {
    if (!analytics) return;
    // Import dinámico para no inflar el bundle si Analytics no carga.
    void import('firebase/analytics').then(({ logEvent }) => {
      logEvent(analytics, 'web_vitals', {
        metric_name: metric.name,
        metric_value: Math.round(metric.value),
        metric_rating: metric.rating,
        metric_id: metric.id,
      });
    });
  });
};

export function reportWebVitals(): void {
  const report: Reporter = (metric) => {
    consoleReporter(metric);
    analyticsReporter(metric);
  };
  onCLS(report);
  onLCP(report);
  onINP(report);
  onFCP(report);
  onTTFB(report);
}
